'use client';
import React from 'react';
import Home from './home/page';

export default function HomePage() {
  return <Home />
}
